import {matchPath, useLocation} from 'react-router-dom';

import {isNilOrEmpty} from 'ramda-adjunct';

import {sourcingRoutes} from '@dms/routes';

import {composePath, Nullish, useNavigate} from 'shared/web';

import {rememberSourcingPrevUrl} from '../constants/rememberSourcingPrevUrl';
import {SourcingType, useSourcingType} from './useSourcingType';

export function useOpenVehicleDetail(adId: string | Nullish, onDetailOpen?: () => void) {
  const navigate = useNavigate();
  const location = useLocation();
  const sourcingType = useSourcingType();
  const detailRoute =
    sourcingType === SourcingType.AUCTIONS
      ? sourcingRoutes.auctionDetail
      : sourcingRoutes.vehicleDetail;
  const isCurrentDetailPage =
    !isNilOrEmpty(adId) && matchPath(detailRoute, location.pathname)?.params.adId === adId;

  const getDetailPath = (preserveSearch = true) =>
    isNilOrEmpty(adId)
      ? ''
      : composePath(detailRoute, {params: {adId}, isSearchParamsPreserved: preserveSearch});

  const rememberOrigin = () => {
    onDetailOpen?.();
    if (
      !matchPath(sourcingRoutes.vehicleDetail, location.pathname) &&
      !matchPath(sourcingRoutes.auctionDetail, location.pathname)
    ) {
      rememberSourcingPrevUrl(location);
    }
  };

  const openDetail = () => {
    if (isNilOrEmpty(adId) || isCurrentDetailPage) {
      return;
    }
    navigate(getDetailPath());
    rememberOrigin();
  };

  return {getDetailPath, isCurrentDetailPage, rememberOrigin, openDetail};
}
